<template>
    <ValidationObserver ref="obs" v-slot="{ invalid, errors }" tag="form" class="container-fluid form-thin mb-4" @submit.prevent="submit">
        <div class="row mb-3">
            <ValidationProvider v-errors tag="div" class="custom-form-group col-12 col-md-6 mb-3 mb-md-0" vid="correction_type" rules="required|included:0,1">
                <small class="text-muted d-block mb-1">Тип коррекции</small>

                <div class="custom-control custom-radio">
                    <input id="correction_type_0" v-model="form.correction_type" type="radio" value="0" class="custom-control-input">
                    <label class="custom-control-label" for="correction_type_0">Самостоятельно</label>
                </div>

                <div class="custom-control custom-radio">
                    <input id="correction_type_1" v-model="form.correction_type" type="radio" value="1" class="custom-control-input">
                    <label class="custom-control-label" for="correction_type_1">По предписанию</label>
                </div>
            </ValidationProvider>

            <ValidationProvider v-errors tag="div" class="custom-form-group col-12 col-md-6" vid="type" rules="required|included:1,3">
                <small class="text-muted d-block mb-1">Признак расчета</small>

                <div class="custom-control custom-radio">
                    <input id="type_1" v-model="form.type" type="radio" value="1" class="custom-control-input">
                    <label class="custom-control-label" for="type_1">Приход</label>
                </div>

                <div class="custom-control custom-radio">
                    <input id="type_3" v-model="form.type" type="radio" value="3" class="custom-control-input">
                    <label class="custom-control-label" for="type_3">Расход</label>
                </div>
            </validationprovider>
        </div>

        <ValidationProvider v-errors tag="div" class="form-group my-4" vid="reason_date" rules="required">
            <label for="reason_date">Дата документа</label>
            <date-picker id="reason_date" v-model="form.reason.doc_date" class="w-100" />
        </ValidationProvider>

        <div class="row mb-2">
            <ValidationProvider v-errors tag="div" class="col-12 col-md-6 form-group" vid="doc_number" rules="required">
                <label for="doc_number">Номер документа</label>
                <input id="doc_number" v-model="form.reason.doc_number" type="text" class="form-control">
            </ValidationProvider>

            <ValidationProvider v-errors tag="div" class="col-12 col-md-6 form-group" vid="doc_name" rules="required">
                <label for="doc_name">Наименование документа</label>
                <input id="doc_name" v-model="form.reason.doc_name" type="text" class="form-control">
            </ValidationProvider>
        </div>

        <div class="row mb-2">
            <ValidationProvider v-errors tag="div" class="col-6 col-sm-3 form-group" vid="cash" rules="required|min_value:0">
                <label for="cash">Наличные</label>
                <input id="cash" v-model="form.payments[0].amount" type="text" class="form-control">
            </ValidationProvider>

            <div class="d-none d-sm-block col-sm-1 form-group">
                <label>&nbsp;</label>
                <div class="text-center cash-delimiter"> + </div>
            </div>

            <ValidationProvider v-errors tag="div" class="col-6 col-sm-3 form-group" vid="cashless" rules="required|min_value:0">
                <label for="cashless">Безнал</label>
                <input id="cashless" v-model="form.payments[1].amount" type="text" class="form-control">
            </ValidationProvider>

            <div class="d-none d-sm-block col-sm-1 form-group">
                <label>&nbsp;</label>
                <div class="text-center cash-delimiter"> = </div>
            </div>

            <ValidationProvider v-errors tag="div" class="offset-6 col-6 offset-sm-0 col-sm-4 form-group" vid="total" rules="required|decimal|min_value:1">
                <input v-model="total" type="hidden">

                <label>Итого</label>
                <div class="cash-delimiter" :class="{ 'text-danger': (errors.total || []).length }">{{ total }} р.</div>
            </ValidationProvider>
        </div>

        <div class="row mb-2">
            <ValidationObserver ref="vats" tag="div" class="col-6 col-sm-3">
                <ValidationProvider v-errors tag="div" vid="amount" rules="required" class="form-group">
                    <label for="vat_0">НДС 18%</label>
                    <input id="vat_0" v-model="form.vats[0].amount" type="text" class="form-control">
                </ValidationProvider>
            </ValidationObserver>

            <ValidationObserver ref="vats" tag="div" class="col-6 col-sm-3">
                <ValidationProvider v-errors tag="div" vid="amount" rules="required" class="form-group">
                    <label for="vat_1">НДС 10%</label>
                    <input id="vat_1" v-model="form.vats[1].amount" type="text" class="form-control">
                </ValidationProvider>
            </ValidationObserver>

            <ValidationObserver ref="vats" tag="div" class="col-6 col-sm-3">
                <ValidationProvider v-errors tag="div" vid="amount" rules="required" class="form-group">
                    <label for="vat_2">НДС 0%</label>
                    <input id="vat_2" v-model="form.vats[2].amount" type="text" class="form-control">
                </ValidationProvider>
            </ValidationObserver>

            <ValidationObserver ref="vats" tag="div" class="col-6 col-sm-3">
                <ValidationProvider v-errors tag="div" vid="amount" rules="required" class="form-group">
                    <label for="vat_3">Без НДС</label>
                    <input id="vat_3" v-model="form.vats[3].amount" type="text" class="form-control">
                </ValidationProvider>
            </ValidationObserver>
        </div>

        <div class="custom-control custom-checkbox my-3">
            <input id="confirm" v-model="confirmed" type="checkbox" class="custom-control-input">
            <label class="custom-control-label" for="confirm">Подтверждаю правильность указанных данных</label>
        </div>

        <div>
            <button :disabled="invalid || !confirmed" type="submit" class="btn btn-lg-192 btn-primary">Создать чек</button>
        </div>
    </ValidationObserver>
</template>

<script>
import DatePicker from '@/components/DatePicker'
import cloneDeep from 'lodash/cloneDeep'

import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { mixinApiErrors } from '@/validation'

const defaultForm = {
    type: null,
    correction_type: null,

    vats: [
        {
            type: 1,
            amount: null
        },
        {
            type: 2,
            amount: null
        },
        {
            type: 3,
            amount: null
        },
        {
            type: 4,
            amount: null
        }
    ],

    reason: {
        doc_number: null,
        doc_name: null,
        doc_date: null
    },

    payments: [
        {
            type: 1,
            amount: null
        },
        {
            type: 2,
            amount: null
        }
    ]
}

export default {
    components: {
        DatePicker,
        ValidationProvider,
        ValidationObserver
    },

    data() {
        return {
            form: cloneDeep(defaultForm),
            confirmed: false
        }
    },

    computed: {
        total: {
            set() {},
            get() {
                const cash = parseFloat(this.form.payments[0].amount) || 0
                const cashless = parseFloat(this.form.payments[1].amount) || 0

                return Math.max(cash + cashless, 0)
            }
        }
    },

    methods: {
        async submit() {
            const isValid = await this.$refs.obs.validate()

            if (!isValid) {
                return
            }

            this.$emit('submit', this.form)
        },

        mixinApiErrors(errors) {
            mixinApiErrors(this.$refs.obs, errors)
        }
    }
}
</script>

<style lang="scss">
@import "../scss/_variables";

.cash-delimiter {
    font-size: $h2-font-size;
    line-height: 2;
}
</style>
